import { GatsbyImage, getImage } from "gatsby-plugin-image"; // For optimized Gatsby images
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaLinkedin } from "react-icons/fa6";
import Button from "./Button"; // Custom Button Component
import { SafeHtmlParser } from "./SafeHtmlParser";

const Team1 = ({ heading, body, teamMembers, button }) => {
	console.log(teamMembers);
	return (
		<section className="py-5 py-lg-7">
			<Container>
				<Row className="mb-5 g-4 g-lg-6">
					<Col xl={6} className=" text-start">
						<div className="text-primary">
							<SafeHtmlParser htmlContent={heading} />
						</div>
						<div className="py-3">
							<SafeHtmlParser htmlContent={body} />
						</div>
						<Button
							colour="#00304B" // Black text button
							text={button.title}
							link={button.url}
							isOutline={true}
							width="w-100 w-md-auto"
						/>
					</Col>
					<Col xl={6}>
						<Row>
							{teamMembers.map((member, index) => {
								const image = getImage(
									member.teamMemberFields.image?.localFile?.childImageSharp
								);
								return (
									<Col
										xs={12}
										md={6}
										lg={4}
										xl={12}
										key={index}
										className="mb-4"
									>
										<Row>
											<Col xs={12} xl={6}>
												{image && (
													<GatsbyImage
														style={{ borderRadius: "12px" }}
														class="h-100 w-100"
														image={image}
														alt={
															member.teamMemberFields.image?.altText ||
															"Team Member"
														}
														className="team-member-image"
													/>
												)}
											</Col>
											<Col xs={12} xl={6}>
												<div className="team-member-card">
													<h5 className="outfit-bold pb-0 mb-1 mt-3">
														{member.teamMemberFields.name}
													</h5>
													<p
														style={{ fontSize: "95%" }}
														className="text-primary pt-0 mt-0"
													>
														{member.teamMemberFields.position}
													</p>
													<p>{member.teamMemberFields.shortDescription}</p>
													<div className="d-flex align-items-center gap-2">
														{/* {member.teamMemberFields.twitterLink && (
															<a
																href={member.teamMemberFields.twitterLink}
																className="dark-link fs-4 me-3"
																target="_blank"
																rel="noopener noreferrer"
															>
																<FaXTwitter />
															</a>
														)} */}
														{member.teamMemberFields.linkedinLink && (
															<a
																href={member.teamMemberFields.linkedinLink}
																className="dark-link fs-4"
																target="_blank"
																rel="noopener noreferrer"
															>
																<FaLinkedin />
															</a>
														)}
													</div>
												</div>
											</Col>
										</Row>
									</Col>
								);
							})}
						</Row>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

// Inline styling for team member cards

export default Team1;
